import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../config/apiconfig';
import { useSettings } from './SettingsContext'; // For token & error handling

const ReportTypeContext = createContext();

export const useReportTypes = () => useContext(ReportTypeContext);

export const ReportTypeProvider = ({ children }) => {
  const [reportTypes, setReportTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { setError: setSettingsError } = useSettings(); // optional global error handler

  useEffect(() => {
  const token = localStorage.getItem('token');

  // ⛔ STOP here if user not logged in
  if (!token) {
    return;
  }

  const fetchReportTypes = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${BASE_URL}/report-types`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status === '200') {
        const types = res.data.data.map(item => ({
          value: item.id,
          label: item.title,
          description: item.description,
        }));
        setReportTypes(types);
      } else {
        throw new Error(res.data.message || 'Failed to fetch report types');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setSettingsError?.(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchReportTypes();
}, [setSettingsError]);


  return (
    <ReportTypeContext.Provider value={{ reportTypes, loading, error }}>
      {children}
    </ReportTypeContext.Provider>
  );
};
